import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from 'gossamer-front-end';
import { BookingList } from './WebsiteAccountLists';

export const WebsiteAccountPortfolioPage = (): React.JSX.Element => {
  const user = useSelector(selectUser);
  return (
    <BookingList
      query={{
        where: {
          and: [
            { fieldId: 'user_id', operator: 'eq', value: user?.userId || '' },
            { fieldId: 'end_at', operator: 'lt', value: new Date().toISOString() },
          ],
        },
        order: [['end_at', 'DESC']],
        offset: 0,
        limit: 100,
      }}
      emptyText="No past events yet."
    />
  );
};
